import { Controller } from 'stimulus';
export default class extends Controller {
  static targets = ['report', 'message', 'url']

  connect() {
    let param_report_id = new URLSearchParams(window.location.search).get("report_id")
    if(param_report_id == this.reportTarget.value){
      this.pollForReportStatus()
    }
  }

  get pollUrl() {
    return this.hasUrlTarget ? this.urlTarget.value : '/client_app/inventory/products/report_status';
  }

  pollForReportStatus(){
    $.ajax({
      url: this.pollUrl,
      method: 'GET',
      data: { report_id: this.reportTarget.value },
      success: response => {
        if(response["file_status"]){
          this.showSuccessModal(response["file"]);
        }else{
          setTimeout(() => this.pollForReportStatus(), 3000);
        }
      }
    })
  }

  showSuccessModal(fileUrl) {
    const modal = this.messageTarget.querySelector('.report-modal-message');
    modal.classList.add('report-modal-message--success');
    modal.innerHTML = `
      <h3 class="text-center font-weight-bold">Tu reporte está listo</h3>
      <div style="display: flex; gap: 0.5rem; justify-content: center;">
        <a href="${fileUrl}" download class="btn btn-primary">Descargar reporte</a>
        <button class="btn btn-outline-secondary" data-action="click->async-reports#closeModal">Cerrar</button>
      </div>
    `;
  }

  closeModal() {
    this.messageTarget.remove();
  }

}
